import clsx from "clsx";
import type { ReactNode } from "react";
import i18n from "../../util/i18n.ts";

const Pagination = ({
	currentPage,
	numRows,
	onClick,
	perPage,
}: {
	currentPage: number;
	numRows: number;
	onClick: (a: number) => void;
	perPage: number;
}) => {
	const showPrev = currentPage > 1;
	const showNext = numRows > currentPage * perPage;
	const numPages = Math.ceil(numRows / perPage);
	let firstShownPage = currentPage <= 3 ? 1 : currentPage - 2;

	while (firstShownPage > 1 && numPages - firstShownPage < 4) {
		firstShownPage -= 1;
	}

	let lastShownPage = firstShownPage + 4;

	if (lastShownPage > numPages) {
		lastShownPage = numPages;
	}

	const numberedPages: ReactNode[] = [];

	for (let i = firstShownPage; i <= lastShownPage; i++) {
		numberedPages.push(
			<li
				key={i}
				className={clsx("page-item", i === currentPage ? "active" : null)}
				data-datatable-pagination-page={i}
			>
				{i === currentPage ? (
					<span
						className="page-link user-select-none"
						onClick={() => onClick(i)}
					>
						{i}
					</span>
				) : (
					<a className="page-link user-select-none" onClick={() => onClick(i)}>
						{i}
					</a>
				)}
			</li>,
		);
	}

	return (
		<ul
			className="pagination mb-0 ms-auto"
			data-datatable-current-page={currentPage}
			data-datatable-page-count={numPages}
			data-datatable-pagination=""
		>
			<li
				className={clsx("page-item", {
					disabled: !showPrev,
				})}
			>
				<a
					className="page-link user-select-none"
					data-datatable-pagination-action="previous"
					onClick={() => showPrev && onClick(currentPage - 1)}
				>
					{i18n.t("dataTable.prev", { ns: "ui", defaultValue: "← Prev" })}
				</a>
			</li>
			{numberedPages}
			<li
				className={clsx("page-item", {
					disabled: !showNext,
				})}
			>
				<a
					className="page-link user-select-none"
					data-datatable-pagination-action="next"
					onClick={() => showNext && onClick(currentPage + 1)}
				>
					{i18n.t("dataTable.next", { ns: "ui", defaultValue: "Next →" })}
				</a>
			</li>
		</ul>
	);
};

export default Pagination;
